module.exports = __webpack_public_path__ + "img/playstore.347c1219.svg";